<template>
  <div class="mt-3">
    <b-button variant="success" size="sm" @click="addAction">
      <span v-if="actionsCount">And</span>
      <span v-else>Do</span>
    </b-button>
  </div>
</template>

<script>
export default {
  props: ['eventBus', 'actionsCount'],
  methods: {
    addAction() {
      this.eventBus.$emit('addAction')
    },
  },
}
</script>
